import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
import { Button } from './ui/Button';
export function Hero() {
  const scrollToPurchase = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15,
        delayChildren: 0.4
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      x: -20
    },
    show: {
      opacity: 1,
      x: 0,
      transition: {
        type: 'spring',
        stiffness: 100
      }
    }
  };
  return <section className="relative pt-6 pb-10 lg:pt-8 lg:pb-14 overflow-visible px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-80">
      <div className="flex justify-center mb-6 lg:mb-8" data-id="element-81">
        <img src="https://cdn.magicpatterns.com/uploads/59hFAgyxREzsQ1LsETU8H2/LOGO_DECO_EMPRENDE-removebg-preview.png" alt="Deco Emprende Logo" className="h-44 sm:h-56 object-contain" data-id="element-82" />
      </div>

      <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center" data-id="element-83">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="max-w-2xl flex flex-col items-center text-center lg:items-start lg:text-left" data-id="element-84">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl leading-[1.1] mb-8 text-deco-text font-bold" data-id="element-85">
            Aprendé a crear piezas deco en{' '}
            <span className="text-deco-terra font-script text-5xl sm:text-6xl lg:text-7xl font-normal px-2" data-id="element-86">
              cemento y yeso
            </span>{' '}
            para <span className="text-deco-terra" data-id="element-87">vender desde casa</span>
          </h1>

          <motion.div variants={containerVariants} initial="hidden" animate="show" className="flex flex-col gap-3 sm:gap-4 mb-6 w-full max-w-md mx-auto lg:mx-0" data-id="element-88">
            {['Materiales fáciles de conseguir', 'No necesitás máquinas ni taller', 'Ideal para empezar desde casa', 'Paso a paso claro para principiantes', 'Incluye 6 módulos + bonos de regalo'].map((bullet, i) => <motion.div key={i} variants={itemVariants} className="flex items-center gap-3 sm:gap-4 bg-deco-card/80 backdrop-blur-sm p-3 sm:p-4 rounded-2xl border border-deco-warm shadow-sm" data-id="element-89">
                <div className="w-8 h-8 sm:w-10 sm:h-10 rounded-full bg-deco-sage/10 flex items-center justify-center text-deco-sage-dark shrink-0" data-id="element-90">
                  <CheckCircle2 size={20} className="sm:w-5 sm:h-5" data-id="element-91" />
                </div>
                <span className="text-deco-text font-medium text-sm sm:text-base text-left" data-id="element-92">
                  {bullet}
                </span>
              </motion.div>)}
          </motion.div>

          <motion.div whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="w-full sm:w-auto rounded-full flex flex-col items-center lg:items-start" data-id="element-93">
            <Button onClick={scrollToPurchase} className="w-full sm:w-auto text-base sm:text-lg px-8 py-4 sm:px-12 sm:py-5 shadow-lg hover:shadow-xl rounded-full bg-deco-terra text-white font-bold transition-all border-2 border-deco-terra/20" data-id="element-94">
              QUIERO EMPEZAR AHORA
            </Button>
            <div className="flex items-center gap-2 mt-4 text-xs sm:text-sm text-deco-muted font-medium" data-id="element-95">
              <ShieldCheck size={16} data-id="element-96" />
              <span data-id="element-97">Acceso inmediato · Producto digital · Pago seguro</span>
            </div>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mt-8 lg:mt-0 px-2 sm:px-0" data-id="element-98">
          <div className="relative rounded-[2rem] sm:rounded-[2.5rem] overflow-hidden shadow-2xl bg-deco-card aspect-square flex items-center justify-center p-2 sm:p-4 border-4 sm:border-8 border-white max-w-md mx-auto" data-id="element-99">
            <video src="https://cdn.magicpatterns.com/uploads/8NY7pNemvbbcMZQ6vjyVAm/WhatsApp Video 2026-05-01 at 12.26.03.mp4" autoPlay loop muted playsInline className="w-full h-full object-cover rounded-[1.5rem] sm:rounded-[2rem]" data-id="element-100" />
          </div>

          <div className="absolute -top-6 -right-6 w-24 h-24 bg-deco-sage/20 rounded-full blur-2xl -z-10" data-id="element-101"></div>
          <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-deco-terra/10 rounded-full blur-2xl -z-10" data-id="element-102"></div>
        </motion.div>
      </div>
    </section>;
}